import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { ListViewToggle } from "~/common/components/list-view-toggle.js";
import { useListViewMode } from "~/common/hooks/use-list-view-mode.js";
import useClanDetailAccess from "~/features/clan-detail/_hooks/useClanDetailAccess.js";
import ClanPlayersOverview from "~/features/clan-players/_components/clan-players-overview.js";

export const Route = createFileRoute("/_authed/my-clans/$tag/players")({
  component: PlayersTab,
});

function PlayersTab() {
  const { t } = useTranslation();
  const { tag } = Route.useParams();
  const { effectiveView, viewMode, setViewMode, isBelowLg } = useListViewMode();
  const { clanTag, isReady, canAccessClan, userIsOwner, effectivePermissions } = useClanDetailAccess({ tag });

  const canCreatePlayers =
    userIsOwner || effectivePermissions.admin || effectivePermissions.createPlayersOnClan;

  const canDeleteConnections =
    userIsOwner || effectivePermissions.admin || effectivePermissions.deletePlayersOnClan;

  if (!isReady || !canAccessClan) return null;

  return (
    <div className="min-w-0 max-w-full space-y-4 overflow-x-hidden">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <h2 className="text-xl font-semibold">{t("app.clanPlayers.title")}</h2>
          <p className="text-sm text-muted-foreground mt-1">{t("app.clanPlayers.description")}</p>
        </div>
        <ListViewToggle isBelowLg={isBelowLg} setViewMode={setViewMode} viewMode={viewMode} />
      </div>
      <ClanPlayersOverview
        actorUserIsOwner={userIsOwner}
        canCreatePlayers={canCreatePlayers}
        canDeleteConnections={canDeleteConnections}
        clanTag={clanTag}
        effectiveView={effectiveView}
      />
    </div>
  );
}
